import request from '@/utils/request'

function summary (storeID) {
  return request({
    url: '/pos/order/summary?storeId=' + storeID,
    method: 'GET'
  })
}

function checkout (data) {
  return request({
    url: '/pos/order/checkout',
    method: 'post',
    data: data
  })
}

function printOrderReceipt (orderId) {
  return request({
    url: '/pos/order/printOrderReceipt?orderId=' + orderId,
    method: 'GET'
  })
}

export default {
  summary,
  checkout,
  printOrderReceipt
}
